import common from 'store/modules/common/api'

export const api = {
  upload: (id, data, onUploadProgress) => common.httpClient.put(`/api/services/app/FileAttachments/Upload?id=${id}`, data, { ...common.options(null, 'multipart/form-data'), onUploadProgress }).then(r => common.processResponse(r))
}
